import { MapContainer, TileLayer } from 'react-leaflet';

import 'leaflet/dist/leaflet.css';
import MapController from './MapController';
import AQIMarkers from '../AQIMarkers/AQIMarkers';
import TemperatureLayer from './TemperatureLayer';
import RegionsLayer from './RegionsLayer';
import { REGION_GEOJSON } from '../../data/regions.geojson';

import './Map.scss';

const Map = ({ temperatureLayer, particleLayer, mapRef, highlightedRegion }) => {
  return (
    <MapContainer center={[39.79, -100.53]} zoom={4} style={{ height: '100%', width: '100%' }}>
      <TileLayer
        opacity={1}
        url="https://tiles.stadiamaps.com/tiles/alidade_smooth/{z}/{x}/{y}{r}.png"
        attribution="&copy; OpenStreetMap contributors"
      />

      <TemperatureLayer temperatureLayer={temperatureLayer} />

      <RegionsLayer data={REGION_GEOJSON} highlighted={highlightedRegion} />

      {particleLayer && <MapController particleLayer={particleLayer} mapRef={mapRef} />}
      <AQIMarkers />
    </MapContainer>
  );
};

export default Map;
